import React, { Fragment, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import CustomLoader from 'src/components/CustomLoader/CustomLoader';
import Header from 'src/components/Header/Header';
import { useCommand } from 'src/hooks/command';
import { unsubscribeUser } from 'src/services/api';
import Confirmation from 'src/views/Unsubscribe/components/Confirmation';

const Unsubscribe = () => {
  const { commandStatus: unsubscribeStatus, command: unsubscribe } =
    useCommand(unsubscribeUser);

  const { id } = useParams();
  useEffect(() => {
    unsubscribe(id);
  });
  const params =
    unsubscribeStatus === 'SUCCESS'
      ? {
          title: "You've been unsubscribed",
          cardTitle: 'Your inbox is a little lighter',
          body: 'Call customer service on 13 73 35 (Mon - Fri, 9am - 5pm AEST) if we can help you with anything else.',
        }
      : {
          title: 'Something went wrong',
          cardTitle: 'You have not been unsubscribed from this email',
          body: 'Contact customer service on 13 73 35 (Mon - Fri, 9am - 5pm AEST) for help.',
        };
  return (
    <Fragment>
      <Header title="Buying a business" />
      {unsubscribeStatus === 'LOADING' && <CustomLoader />}
      {unsubscribeStatus !== 'LOADING' && <Confirmation {...params} />}
    </Fragment>
  );
};

export default Unsubscribe;
